/* ============================================================================
   THE BODIE CO — EDITORIAL LAYER (JS)
   Vanilla, no dependencies. ~2KB. Progressive enhancement only:
   nothing here is required for browsing, purchasing or checkout.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------- Scroll reveal */
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.bd-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------------- FAQ */
  function initFaq(root) {
    var btns = (root || document).querySelectorAll('.bd-faq__q');
    btns.forEach(function (btn) {
      if (btn.dataset.bdBound) return;
      btn.dataset.bdBound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = false;
        panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
        if (open) {
          window.setTimeout(function () {
            if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true;
          }, 420);
        }
      });
    });

    // Keep an open panel correctly sized on resize
    window.addEventListener('resize', function () {
      document.querySelectorAll('.bd-faq__q[aria-expanded="true"]').forEach(function (b) {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.style.maxHeight = p.scrollHeight + 'px';
      });
    }, { passive: true });
  }

  /* ------------------------------------------- Sticky mobile purchase CTA */
  function initStickyAtc() {
    var bar = document.querySelector('.bd-sticky-atc');
    if (!bar) return;
    var anchor = document.querySelector('.product-single__form') ||
                 document.querySelector('.product-block--price') ||
                 document.querySelector('.product-single__meta');
    if (!anchor || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);

    var btn = bar.querySelector('[data-bd-atc]');
    if (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var real = document.querySelector('.product-single__form [type="submit"], .product-single__form button[name="add"]');
        if (real) {
          real.click();
        } else if (anchor && anchor.scrollIntoView) {
          anchor.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }
  }

  /* ------------------------------------------------------------ Boot */
  function boot() {
    initReveal(document);
    initFaq(document);
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run inside the Theme Editor when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initFaq(e.target);
    initStickyAtc();
  });
})();
